import Accounts from '@account/views/AccountsView'
import Dashboard from '@dashboard/views/DashboardView'
import * as React from '@integrations/react'
import Expenses from '@requests/views/RequestsView'
import Transactions from '@transactions/views/TransactionsView'
import { paths } from 'mmfintech-backend-api'
import type { RouteDefinition } from 'mmfintech-backend-api/types'

const LazyPaymentMethodsView = React.lazy(() => import('@paymentMethods/views/PaymentMethodsView/PaymentMethodsView'))
const LazySupportView = React.lazy(() => import('@support/views/SupportView/SupportView'))
const LazyQuestionnaireKybView = React.lazy(() => import('@onboarding/views/QuestionnaireKybView'))
const LazyQuestionnaireSuccessView = React.lazy(() => import('@onboarding/views/QuestionnaireSuccessView'))
const LazyOnboardingVerificationView = React.lazy(() => import('@onboarding/views/VerificationView'))

// prettier-ignore
export const protectedRoutes: RouteDefinition[] = [
  { path: paths.root(), redirect: paths.dashboard() },

  { path: paths.dashboard(), component: Dashboard },
  { path: paths.settings(), component: React.lazy(() => import('@settings/views/SettingsView')) },
  { path: paths.externalAccounts(), component: React.lazy(() => import('@settings/views/SettlementAccountsView')) },
  { path: paths.scanAndPay(), component: React.lazy(() => import('@scanAndPay/views/ScanAndPayView')) },

  { path: paths.developer(), component: React.lazy(() => import('@developer/views/DeveloperView')) },
  { path: paths.userManagement(), component: React.lazy(() => import('@users/views/UsersView')) },
  { path: paths.referralProgram(), component: React.lazy(() => import('@referAndEarn/views/ReferAndEarnView')) },
  { path: paths.paymentMethods(), component: LazyPaymentMethodsView },

  { path: paths.banking.accounts.list(), component: Accounts },
  { path: paths.banking.deposit(), component: React.lazy(() => import('@banking/views/DepositView')) },
  { path: paths.banking.expenses(), component: Expenses },
  { path: paths.banking.exchange(), component: React.lazy(() => import('@banking/views/ExchangeView')) },
  {
    path: paths.banking.sendBatchPayment(),
    component: React.lazy(() => import('@banking/views/BatchPaymentView'))
  },
  {
    path: paths.banking.transactions.batchList(),
    component: React.lazy(() => import('@batchOverview/views/BatchOverviewView'))
  },
  {
    path: paths.banking.sendIntraAccountTransfer(),
    component: React.lazy(() => import('@banking/views/IntraAccountTransferView'))
  },
  {
    path: paths.banking.sendTransfer(),
    component: React.lazy(() => import('@banking/views/InternalTransferView'))
  },
  {
    path: paths.banking.transactions.details(':transactionId'),
    component: React.lazy(() => import('@transactions/views/TransactionDetailsView'))
  },
  { path: paths.banking.transactions.listByAccountId(':accountId'), component: Transactions },
  { path: paths.banking.transactions.list(), component: Transactions },

  { path: paths.payout.select(), component: React.lazy(() => import('@banking/views/PayoutSelectionView')) },
  { path: paths.payout.crypto(), component: React.lazy(() => import('@banking/views/PayoutCryptoView')) },
  { path: paths.payout.bankTransfer(), component: React.lazy(() => import('@banking/views/PayoutBankTransferView')) },

  { path: paths.withdraw.select(), component: React.lazy(() => import('@banking/views/WithdrawSelectionView')) },
  { path: paths.withdraw.crypto(), component: React.lazy(() => import('@banking/views/WithdrawCryptoView')) },
  {
    path: paths.withdraw.bankTransfer(),
    component: React.lazy(() => import('@banking/views/WithdrawBankTransferView'))
  },
  {
    path: paths.withdraw.kingdomWallet(),
    component: React.lazy(() => import('@banking/views/WithdrawKingdomWalletView'))
  },
  {
    path: paths.withdraw.jetonBankWallet(),
    component: React.lazy(() => import('@banking/views/WithdrawJetonbankWalletView'))
  },

  {
    path: paths.recipients.details(':recipientId'),
    component: React.lazy(() => import('@recipients/views/RecipientDetailsView'))
  },
  { path: paths.recipients.list(), component: React.lazy(() => import('@recipients/views/RecipientsView')) },

  { path: paths.onboarding.questionnaireKyb(), component: LazyQuestionnaireKybView },
  { path: paths.onboarding.questionnaireKybSuccess(), component: LazyQuestionnaireSuccessView },
  { path: `${paths.onboarding.continueOnboarding()}/:merchantType`, component: LazyOnboardingVerificationView },
  { path: paths.onboarding.continueOnboarding(), component: LazyOnboardingVerificationView },
  { path: `${paths.support.tickets()}/:ticketId?`, component: LazySupportView }
]
